export enum GeolocationAction {
    started = 'started',
    ended = 'ended',
    canceled = 'canceled',
    after = 'after',
    before = 'before',
}

export enum GeolocationActionType {
    Shift = 'shift',
    RoutePerformance = 'route_performance',
    SitePerformance = 'site_performance',
    PhotoPerformance = 'photo_performance',
}

export enum LocationPermissionStatus {
    Allowed = 'allowed',
    AppDenied = 'app_denied',
    DeviceDenied = 'device_denied'
}